(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    /* Countdown timers. Real end dates only: the sale_ends_at metafield,
   or local midnight for products tagged "Daily Deal". */
(function () {
  if (window.__aaCountdownInit) return;
  window.__aaCountdownInit = true;

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function endOf(el) {
    var v = el.getAttribute('data-aa-countdown');
    if (v === 'midnight') {
      var d = new Date();
      d.setHours(24, 0, 0, 0);
      return d.getTime();
    }
    return Date.parse(v);
  }

  function tick() {
    var now = Date.now();
    document.querySelectorAll('[data-aa-countdown]').forEach(function (el) {
      var end = endOf(el);
      if (isNaN(end)) { el.style.display = 'none'; return; }
      var diff = Math.floor((end - now) / 1000);
      if (diff <= 0) { el.style.display = 'none'; return; }
      el.textContent = pad(Math.floor(diff / 3600)) + ':' + pad(Math.floor((diff % 3600) / 60)) + ':' + pad(diff % 60);
    });
  }

  tick();
  setInterval(tick, 1000);
})();
  } catch(e) { console.error(e); }
})();

})();
